import { essIncomingBatchesFactory } from '@eas/common-web';
import { ExportTags } from '@enums';

export const EssIncomingBatches = essIncomingBatchesFactory(
  '/api/evidence-spisu/ess/incoming-batches',
  ExportTags.ESS_INCOMING_BATCHES_GRID
);
